// Environment-configurable API endpoints
const getApiBaseUrl = (service) => {
  // Next.js only exposes NEXT_PUBLIC_* values to client bundles when the
  // property access is statically analyzable.
  const publicUrls = {
    auth:
      process.env.NEXT_PUBLIC_AUTH_API_URL ||
      "https://auth-api.manabakh.ir",
    cms:
      process.env.NEXT_PUBLIC_CMS_API_URL ||
      "https://cms-api.manabakh.ir",
    billing:
      process.env.NEXT_PUBLIC_BILLING_API_URL ||
      "https://billing-api.manabakh.ir",
    gamification:
      process.env.NEXT_PUBLIC_GAMIFICATION_API_URL ||
      "https://gamification-api.manabakh.ir",
    ad:
      process.env.NEXT_PUBLIC_AD_API_URL ||
      "https://advertisement-api.manabakh.ir",
    support:
      process.env.NEXT_PUBLIC_SUPPORT_API_URL ||
      "https://support-api.manabakh.ir",
  };

  const serverUrls = {
    auth: process.env.AUTH_API_URL,
    cms: process.env.CMS_API_URL,
    billing: process.env.BILLING_API_URL,
    gamification: process.env.GAMIFICATION_API_URL,
    ad: process.env.AD_API_URL,
    support: process.env.SUPPORT_API_URL,
  };

  // For SSR (server-side), use process.env
  if (typeof window === 'undefined') {
    return serverUrls[service] || publicUrls[service] || `https://${service}-api.manabakh.ir`;
  }

  return publicUrls[service] || `https://${service}-api.manabakh.ir`;
};

export const getAuthApiRoute = (url) =>
  `${getApiBaseUrl('auth')}/v1/auth/api/${url}`;

export const getCMSApiRoute = (url) =>
  `${getApiBaseUrl('cms')}/v1/cms/api/${url}`;

export const getBillingApiRoute = (url) =>
  `${getApiBaseUrl('billing')}/v1/billing/api/${url}`;

export const getGamificationApiRoute = (url) =>
  `${getApiBaseUrl('gamification')}/v1/gamification/api/${url}`;

export const getAdApiRoute = (url) =>
  `${getApiBaseUrl('ad')}/v1/advertisement/api/${url}`;

export const getSupportApiRoute = (url) =>
  `${getApiBaseUrl('support')}/v1/support/api/${url}`;

const getRtEventBaseUrl = () => {
  const publicUrl =
    process.env.NEXT_PUBLIC_RT_EVENT_API_URL || 'https://rt-event.manabakh.ir';

  if (typeof window === 'undefined') {
    return process.env.RT_EVENT_API_URL || publicUrl;
  }

  return publicUrl;
};

export const getRtEventApiRoute = (url) =>
  `${getRtEventBaseUrl()}/v1/rt-event/api/${url}`;

/**
 * Resolve a profile image value into a full URL.
 * Matches the Flutter logic: if it already starts with 'http', use as-is;
 * otherwise prepend the Auth V2 public user-media base URL.
 *
 * @param {string|null|undefined} imageValue - raw profileImage from profile data
 * @returns {string|null} full image URL or null if no image
 */
export const getProfileImageUrl = (imageValue) => {
  if (!imageValue) return null;
  if (imageValue.startsWith('http')) return imageValue;
  return encodeURI(
    `${getApiBaseUrl('auth')}/v1/auth/api/user-media/${imageValue}`
  );
};
